var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 40,
    viewBox: "0 0 26 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.804 17.98V4.684A3.895 3.895 0 018.688.801h8.223a3.895 3.895 0 013.886 3.883V17.98M4.675 34.307v-.797a2.783 2.783 0 012.775-2.776h10.699a2.785 2.785 0 012.776 2.776v.803m-8.125-.019v-8.297m10.548-3.465c0 .611-.5 1.11-1.11 1.11H3.362c-.61 0-1.11-.499-1.11-1.11v-3.354c0-.61.5-1.11 1.11-1.11h18.876c.61 0 1.11.5 1.11 1.11v3.354z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.348 22.532c0 .611-.5 1.11-1.11 1.11H3.362c-.61 0-1.11-.499-1.11-1.11v-3.354c0-.61.5-1.11 1.11-1.11h18.876c.61 0 1.11.5 1.11 1.11v3.354z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.772 12.027h-2.69s-1.773 0-1.149 2.672l1.322 6.14m18.589-8.812h2.675s1.772 0 1.148 2.672l-1.322 6.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.396 38.607a.595.595 0 11-.595-.595c.33 0 .595.265.595.595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.396 38.607a.595.595 0 11-.595-.595c.33 0 .595.265.595.595z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.192 38.607a.594.594 0 11-1.19 0 .595.595 0 111.19 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.192 38.607a.594.594 0 11-1.19 0 .595.595 0 111.19 0z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 38.607a.596.596 0 01-1.192 0 .596.596 0 011.192 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 38.607a.596.596 0 01-1.192 0 .596.596 0 011.192 0z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.2aa3714674ed4c0f4a298b2416db39bb.svg";
export { ForwardRef as ReactComponent };